import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const ChecklistIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Reviews</title>;
    t1 = <path d="M2.16699 10.0001C2.16699 6.07171 2.16699 4.10752 3.38738 2.88714C4.60777 1.66675 6.57195 1.66675 10.5003 1.66675C14.4287 1.66675 16.3929 1.66675 17.6133 2.88714C18.8337 4.10752 18.8337 6.07171 18.8337 10.0001C18.8337 13.9285 18.8337 15.8926 17.6133 17.113C16.3929 18.3334 14.4287 18.3334 10.5003 18.3334C6.57195 18.3334 4.60777 18.3334 3.38738 17.113C2.16699 15.8926 2.16699 13.9285 2.16699 10.0001Z" stroke="currentColor" strokeWidth="1.5" />;
    t2 = <path d="M5.5 13.1667L6.45238 14.1667L8.83333 11.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M5.5 7.33325L6.45238 8.33325L8.83333 5.83325" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M11.333 7.5L15.4997 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t5 = <path d="M11.333 13.3333L15.4997 13.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 20" fill="none" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}</svg>;
    $[6] = props;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};